import React from 'react';

import styles from './style.scss';


const VerticalBookCardEmpty = () => (
  <div className={styles.tinyBook}>
    <div className={styles.bookCover} />
    <div className={styles.rating} />
    <div className={styles.bookName} />
    <div className={styles.bookAuthor} />
    <div className={styles.bookAuthorEnd} />
  </div>
);

export default VerticalBookCardEmpty;
